<template>
    <div v-if="certificateId">
        <form @submit.prevent="generateCertificate()" method="get">
            <button type="submit" class="border-0 shadow-none box" style="outline: 0; cursor: pointer">
                <div class="img"><img :src="this.image" alt=""></div>
                <div class="title" v-html="this.title"></div>
            </button>
        </form>
    </div>
    <div v-else-if="isEnd == true">
        <h5><br/><br/>Aktualnie nie uzyskałeś jeszcze żadnego certyfikatu.</h5>
    </div>
    <div v-else-if="isEnd == false">
        <h5><br/><br/>Będzie możliwy do wygenerowania po zakończeniu konferencji.</h5>
    </div>
</template>

<script>
export default {
    props: ['image', 'title', 'event_id'],

    data() {
        return {
            certificateId: null,
            isEnd: null,
        }
    },
    beforeMount() {
        axios.get('/api/certificateId', {
            params: {
                eventableId: this.event_id,
                eventableType: 'App\\Models\\Event',
            }
        }).then(response => {
            this.certificateId = response.data.data.certificateId
            if (!this.certificateId){
                this.eventEnd();
            }
        }).catch(error => {
            this.$notify({
                'group': 'foo',
                'type': 'error',
                'title': error.response.data.errors.code[0]
            })
        });
    },
    methods: {
        eventEnd(){
            axios.get('/api/eventEnd', {
                params: {
                    eventableId: this.event_id,
                    eventableType: 'App\\Models\\Event',
                }
            })
                .then(response => {
                    this.isEnd = response.data.data.isEnd
                }).catch(error => {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': error.response.data.errors.code[0]
                })
            });
        },

        generateCertificate(){
            if (this.certificateId === null || this.certificateId === undefined) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy skontaktować się z administracją'
                });

                return false;
            }
            axios({
                url: '/profil/'+this.certificateId+'/getCertificate',
                method: 'GET',
                responseType: 'blob',
            })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'certyfikat.png');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$notify({
                        'group': 'foo',
                        'type': 'success',
                        'title': 'Certyfikat został pobrany pomyślnie'
                    });
                });
        },
    },
}
</script>
